import type { PrototypePiece } from '../data/contracts';

/** COMPILE-ASYNC (GAP-8) : choix « ignorer cette pièce pour cette version », journalisé dans le reçu de la compilation. */
export const IGNORE_PIECE = '__ignore__';
export type UntargetedPiece = { pieceRef: string; fileName: string; kind: string; label?: string };
export type IgnoredPiece = { pieceRef: string; fileName: string; kind: string };

export function untargetedPiece(piece: PrototypePiece): UntargetedPiece {
  return { pieceRef: piece.id, fileName: piece.fileName || piece.label || piece.id, kind: piece.kind, ...(piece.label ? { label: piece.label } : {}) };
}

const fold = (value: string) => value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
/** GAP-21 (passe réelle n° 2 de Finances) : une capture dont le libellé est celui d'une page, ou commence par lui suivi d'un séparateur
 * de sous-écran (« Mon budget › Tout », « Comprendre & agir › Ma feuille de route »), désigne cette page : l'association est proposée
 * d'office (le Maker peut la changer). Le libellé le plus long l'emporte ; deux pages de même libellé : aucune proposition. */
export function suggestedPieceTarget(piece: UntargetedPiece, pages: { key: string; label?: Record<string, string> }[]): string | undefined {
  const label = piece.label?.trim();
  if (!label) return undefined;
  const head = fold(label.split(/\s*[›»>|/:–—-]\s+/u)[0] ?? '');
  const whole = fold(label);
  const matches = pages.flatMap(page => [...new Set(Object.values(page.label ?? {}).map(fold).filter(Boolean))]
    .filter(name => name === whole || name === head).map(name => ({ key: page.key, length: name.length })));
  const best = Math.max(0, ...matches.map(match => match.length));
  const keys = [...new Set(matches.filter(match => match.length === best).map(match => match.key))];
  return keys.length === 1 ? keys[0] : undefined;
}
